export const environment = {
  production: true,
  extension: false,
  service_url: 'https://service.pdfhubonline.com/',
  path: {
    merge: 'api/merge/',
    convert: 'api/convert/'
  }
};
